import { useContext, useEffect, useState } from "react"
import Get from "../../api/Get"
import Post from "../../api/Post"
import Put from "../../api/Put"
import { Row, Col } from 'react-bootstrap'
import { GET_PLANES, GET_TIPOPLAN_ALL, TIPOPLAN_ADD, TIPOPLAN_UPDATE } from "../../api/Routes"
import Filtro from "../../components/catalogos/Filtro"
import { authContext } from "../../context/AuthContext"
import LoadingList from "../../loader/LoadingList"
import AddTipoPlan from "./tipoplan/AddTipoPlan"
import TipoPlanList from "./tipoplan/TipoPlanList"
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever"

function TipoPlanIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }
    const [errorServer, setErrorServer] = useState(null)

    useEffect(() => cargarReligiones(), [])

    const cargarReligiones = () => {
        setLoading(true)
        Get({url: GET_TIPOPLAN_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            console.log(resp)
            setItems(resp.data.data.response)
            setLoading(false)
            
        })
        .catch((error) => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const agregar = (values) => {
        setLoading(true)
        values.active = true;
        Post({url: TIPOPLAN_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            console.log(response)
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})            
            setLoading(false)
        })                
        .catch((error) => {
            console.log("Error encontrado", error)
            setShowModalServer(true)
            setErrorServer(error?.response)
            setLoading(false) 
        })
    }

    const editar = (values) =>{
        Put({url: TIPOPLAN_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            const copyIt = [...items]
            const idx = items.findIndex(it=>it.id === response.data.data.id)
            if(idx>=0){
                copyIt[idx] = response.data.data;
                setItems(copyIt)
            }
            //ok     
        })                
        .catch((error) => {
            setLoading(false)     
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            <Filtro catName ='Planes'/>
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddTipoPlan agregar={agregar} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <TipoPlanList items={items} 
                        editar={editar}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>

        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
    </>)
}

export default TipoPlanIndex